import {Component, effect, input, output, signal, ChangeDetectionStrategy} from "@angular/core"
import {CheckboxComponent} from "@common/components/inputs/checkbox/checkbox.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-native-checkbox",
    templateUrl: "./native-checkbox.component.html",
    styleUrls: ["./native-checkbox.component.scss"],
    imports: [CheckboxComponent],
})
export class NativeCheckboxComponent {
    readonly $value = input.required<string>({alias: "value"})
    readonly $checked = input<boolean | undefined>(undefined, {alias: "checked"})
    readonly $connectedSelectionList = input<Set<string> | undefined>(undefined, {alias: "connectedSelectionList"})

    readonly valueChange = output<boolean>()

    // Writable signal for 2-way binding
    readonly $isChecked = signal<boolean>(false)

    constructor() {
        effect(() => {
            const checked = this.$checked()
            if (checked !== undefined) {
                this.$isChecked.set(checked)
            }
        })

        effect(() => {
            const connectedSelectionList = this.$connectedSelectionList()
            const value = this.$value()
            this.$isChecked.set(connectedSelectionList?.has(value) ?? false)
        })
    }

    onValueChange(checked: boolean) {
        const connectedSelectionList = this.$connectedSelectionList()
        if (connectedSelectionList) {
            if (checked) {
                connectedSelectionList.add(this.$value())
            } else {
                connectedSelectionList.delete(this.$value())
            }
        }

        this.valueChange.emit(checked)
    }
}
